import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import useBreadcrumbBarAsFirstComponent from '../../../hooks/useBreadcrumbBarAsFirstComponent';
import { THeroCarouselDesktopProps } from '../types/herobanner.types';
import CarouselForEE from './carousel/CarouselForEE';
import Carousel from './carousel/Carousel';

const HeroCarouselDesktop: FC<THeroCarouselDesktopProps> = ({ items, showCarouselOverlay, sitecoreContext, headingTag }) => {
  const isEEActive = sitecoreContext?.pageEditing;
  const isPreview = sitecoreContext?.pageState === 'preview';
  const isBreadcrumbShown = useBreadcrumbBarAsFirstComponent([]);

  const carousel = isEEActive ? (
    <CarouselForEE items={items} />
  ) : (
    <Carousel isPreview={isPreview} items={items} headingTag={headingTag} showCarouselOverlay={showCarouselOverlay} />
  );

  return (
    <section className={`hero-banner carousel-wrapper hero-carousel ${isBreadcrumbShown ? 'with-breadcrumb-bar' : ''}`}>{carousel}</section>
  );
};

export default withSitecoreContext()(HeroCarouselDesktop);
